
// Page scrolling configuration
$(function() {
    $.scrollIt ({
        topOffset: -85,
        scrollTime: 150
    });
});
